import { Container, Graphics, Text, type Ticker } from 'pixi.js';

import { seasonLabels, weatherLabels } from '../engine/seasons/SeasonTypes';
import type { GameWorldSnapshot } from '../engine/world/types';

export class DebugPanel {
  readonly root = new Container();
  private readonly background = new Graphics();
  private readonly text = new Text({
    text: '',
    style: { fill: '#bde6ff', fontFamily: 'Consolas, monospace', fontSize: 13, lineHeight: 17 },
  });

  constructor() {
    this.root.addChild(this.background, this.text);
    this.root.position.set(1512, 154);
    this.text.position.set(12, 12);
    this.background.rect(0, 0, 390, 320).fill({ color: 0x071018, alpha: 0.78 }).stroke({ color: 0x4b8da8, width: 1 });
  }

  update(snapshot: GameWorldSnapshot, ticker: Ticker): void {
    const fps = Math.round(ticker.FPS);
    this.text.text = [
      'Debug PixiJS',
      `FPS: ${fps}`,
      `Tiles: ${snapshot.map.tiles.length}`,
      `Gebäude: ${snapshot.buildings.length}`,
      `Einheiten: ${snapshot.units.length}`,
      `Jahr ${snapshot.season.year} · ${seasonLabels[snapshot.season.currentSeason]} Tag ${snapshot.season.seasonDay}`,
      `Wetter: ${weatherLabels[snapshot.season.currentWeather]}`,
      `Nahrung x${snapshot.season.production.food}`,
      `Bewegung x${snapshot.season.production.movement}`,
      `Phase: ${snapshot.gameplay.phase}`,
      `Bevölkerung: ${snapshot.gameplay.population} (${snapshot.gameplay.chatterCount} Chatter / ${snapshot.gameplay.npcCount} NPC)`,
      `ViewerCharacters: ${snapshot.gameplay.viewerCharacters.length}`,
      `NPC-Limit: ${snapshot.gameplay.balancing.npcLimit}`,
      `Quest: ${formatQuest(snapshot.gameplay.activeQuests[0])}`,
      `Forschung: ${formatResearch(snapshot.gameplay.activeResearch[0])}`,
      `Kette: ${formatChain(snapshot.gameplay.productionChains[0])}`,
      `Projekt: ${formatProject(snapshot.gameplay.community.projects[0])}`,
      `Vote: ${formatVote(snapshot.gameplay.community.votes[0])}`,
      `Offline: ${snapshot.gameplay.viewerCharacters[0]?.offlineProgress.message ?? 'keine Daten'}`,
      `Command: ${snapshot.gameplay.commandLog[0]?.command ?? 'keiner'}`,
	  `Fehlende Saison-Kacheln: ${snapshot.season.missingSeasonTiles.length}`,
      'Fehlende Wasser-Autotiles: ja',
      'Debug per ?debug=1',
    ].join('\n');
  }
}

function formatQuest(quest: GameWorldSnapshot['gameplay']['activeQuests'][number] | undefined): string {
  if (!quest) return 'keine';
  return `${quest.label} ${Math.round(quest.progress)}/${quest.goal}`;
}

function formatResearch(research: GameWorldSnapshot['gameplay']['activeResearch'][number] | undefined): string {
  if (!research) return 'frei';
  return `${research.label} ${Math.round(research.progress * 100)}%`;
}

function formatChain(chain: GameWorldSnapshot['gameplay']['productionChains'][number] | undefined): string {
  if (!chain) return 'keine';
  return `${chain.label} ${Math.round(chain.progress * 100)}%`;
}

function formatProject(project: GameWorldSnapshot['gameplay']['community']['projects'][number] | undefined): string {
  if (!project) return 'keines';
  return `${project.label} ${Math.round((project.progress / project.goal) * 100)}%`;
}

function formatVote(vote: GameWorldSnapshot['gameplay']['community']['votes'][number] | undefined): string {
  if (!vote) return 'keine';
  const votes = Object.keys(vote.votes).length;
  return vote.closed ? `${vote.label}: ${vote.winner ?? 'offen'} (${votes})` : `${vote.label}: ${votes} Stimmen`;
}
